import React, { Component } from "react";
import BookingSlider from "./sliderForBooking";
import InProgressRecurringOne from './InProgressRecurring1';
import InProgressOne from "./InProgressNew";
import InProgressTwo from "./InProgress2";
import InProgressThree from "./InProgress3";
import InProgressFour from "./InProgress4";
import RepeatBookingStep from './RepeatBookingStep';

export default class  InProgressBooking extends Component {
  state = {
    inProgressStep: 1
  };

  changeProgressStep = step => {
    this.setState({ inProgressStep: step });
  };

  render() {
    const { inProgressStep } = this.state;
    let component = <div />;

    switch (inProgressStep) {
      case 1:
        component = this.props.isCustom ? (<InProgressRecurringOne isRecurring={this.props.isRecurring} chef={this.props.chef} changeProgressStep={this.changeProgressStep} handleToggle={this.props.handleToggle} />) : (
          <InProgressOne isRecurring={this.props.isRecurring} changeProgressStep={this.changeProgressStep} handleToggle={this.props.handleToggle} />
        );
        break;

      case 2:
        component = (
          <RepeatBookingStep changeProgressStep={this.changeProgressStep} isCustom={this.props.isCustom} chef={this.props.chef} />
        );
        break;

      case 3:
        component = (
          <InProgressTwo changeProgressStep={this.changeProgressStep} isCustom={this.props.isCustom} chef={this.props.chef} />
        );
        break;

      case 4:
        component = (
          <InProgressThree changeProgressStep={this.changeProgressStep} isCustom={this.props.isCustom} chef={this.props.chef} />
        );
        break;

      case 5:
        component = (
          <InProgressFour
            changeProgressStep={this.changeProgressStep}
            isCustom={this.props.isCustom}
            {...this.props}
            chef={this.props.chef}
          />
        );
        break;

      default:
        component = <InProgressOne />;
    }

    return (
      <div>
        <BookingSlider
          toggleDrawer={this.props.toggleBookingDrawer}
          handleToggle={this.props.handleToggle}
          changeProgressStep={this.changeProgressStep}
          step={inProgressStep}
          style={{ paddingLeft: 20, width: 480 }}
        //  children={component}
        >
         {component}
        </BookingSlider>
      </div>
    );
  }
}
